<template>
  <van-collapse v-model="activeNames">
    <van-collapse-item class="r-1" title="纳税信息" name="1">
      <van-cell-group><van-field label="纳税人名称" :value="data.taxpayerName" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="纳税人识别号" :value="data.taxpayerNumber" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="组织机构代码" :value="data.orgCode" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="注册地址" :value="data.address" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="发布日期" :value="data.publishTime" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="案件性质" :value="data.caseNature" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="所属税务机关" :value="data.taxGov" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="主要违法事实、相关法律依据及税务处理处罚情况" :value="data.illegalContent" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
    <van-collapse-item title="法定代表人信息" name="2">
      <van-cell-group><van-field label="法定代表人姓名" :value="data.operInfo.operName" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="法定代表人证件号" :value="data.operInfo.operCerNo" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="法定代表人性别" :value="data.operInfo.operGender" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="法定代表人证件类型" :value="data.operInfo.operCerType" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
    <van-collapse-item title="负有责任的财务负责人信息" name="3">
      <van-cell-group><van-field label="财务负责人证件号" :value="data.financeChiefInfo.financeChiefCerNo" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="财务负责人性别" :value="data.financeChiefInfo.financeChiefGender" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="财务负责人名称" :value="data.financeChiefInfo.financeChiefName" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="财务负责人Id" :value="data.financeChiefInfo.financeChiefId" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="财务负责人证件类型" :value="data.financeChiefInfo.financeChiefCerType" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
    <van-collapse-item title="负有责任的中介机构" name="4">
      <van-cell-group><van-field label="负有责任的中介机构名称" :value="data.agencyInfo.agencyCompanyName" placeholder="无" readonly /></van-cell-group>
      <!-- <van-cell-group><van-field label="负有责任的中介KeyNo" :value="data.agencyInfo.agencyKeyNo" placeholder="无" readonly /></van-cell-group> -->
      <van-cell-group><van-field label="负有责任的中介人员名" :value="data.agencyInfo.agencyPersonName" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="负有责任的中介证件类型" :value="data.agencyInfo.agencyPersonCerType" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="负有责任的中介证件号" :value="data.agencyInfo.agencyPersonCerNo" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="负有责任的中介性别" :value="data.agencyInfo.agencyPersonGender" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
  </van-collapse>
</template>

<script>
import detailMixin from "../mixins/detail-mixin"
export default {
  name: "taxIllegalCheckDetail",
  mixins: [detailMixin],
  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
      companyInfoListCol: [
        {title: "序号", field: "sort" },
        // {title: "KeyNo", field: "keyNo"},
        {title: "名称", field: "name"}
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "../style.scss";
.r-1 /deep/ .van-collapse-item__content {
  padding: 0px 16px;
}
.coll2 .van-cell__value {
  flex: 1;
  margin-left: 8px;
}
.coll2 .van-cell {
  padding: 10px 0;

  &::after{
    left: 0;
  }
}

.coll3 /deep/ .van-field__label {
  flex: 1;
}
</style>